import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInboxLineCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 81,
	height: 80,
	viewBox: "0 0 81 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		width: 80,
		height: 80,
		rx: 40,
		fill: "#F6F6F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M46.342 29.334C47.2799 29.334 48.143 29.826 48.6232 30.6197L48.7271 30.8081L53.4104 40.1747C53.6419 40.6375 53.7808 41.14 53.8207 41.6539L53.8327 41.9635V49.334C53.8327 50.7398 52.7449 51.8915 51.365 51.9933L51.166 52.0007H29.8327C28.4269 52.0007 27.2751 50.9128 27.1733 49.533L27.166 49.334V41.9635C27.166 41.446 27.2664 40.9345 27.4606 40.4569L27.5883 40.1747L32.2716 30.8081C32.691 29.9692 33.5172 29.4172 34.4417 29.3426L34.6567 29.334H46.342ZM35.166 42.6673H29.8327V49.334H51.166V42.6673H45.8327V43.334C45.8327 44.4385 44.9372 45.334 43.8327 45.334H37.166C36.0614 45.334 35.166 44.4385 35.166 43.334V42.6673ZM46.342 32.0007H34.6567L30.6567 40.0007H35.8327C36.8723 40.0007 37.7266 40.7939 37.8235 41.808L37.8327 42.0007V42.6673H43.166V42.0007C43.166 40.9611 43.9592 40.1067 44.9734 40.0098L45.166 40.0007H50.342L46.342 32.0007Z",
		fill: "#8C8C8C"
	})]
});
export default SvgInboxLineCircle;
